import { Button, Dropdown, Empty, Menu, Modal, Table } from 'antd';
import React from 'react';
import ReactDragListView from 'react-drag-listview';
import { Resizable } from 'react-resizable';
import { Icon } from 'xadmin-ui';
import './EditTable.css';
import { EllipsisOutlined, EditOutlined } from '@ant-design/icons';

const ResizeableTitle = (props) => {
  const { onResize, width, ...restProps } = props;

  if (!width) return <th {...restProps} />

  return (
    <Resizable width={width} height={0} onResize={onResize}>
      <th {...restProps} />
    </Resizable>
  )
}

const MenuData = [
  // { key: "editName", value: "修改列名" },
  // { key: 'editForm', value: '修改属性' },
  { key: 'remove', value: '删除此列' },
  { key: 'copy', value: '复制此列' },
  { key: 'addBefore', value: '向前加一列' },
  { key: 'addAfter', value: '向后加一列' },
]

class ColumnsDropDown extends React.Component {

  state = { visible: false }

  onMovement = () => this.setState({ visible: false })

  handleMenuClick = (e) => {
    // MenuData
    const { fields, index } = this.props
    switch (e.key) {
      case 'editName':
        break;
      case 'editForm':
        this.setState({ visible: true })
        break;
      case 'remove':
        fields.remove(index)
        break;
      case 'copy':
        fields.push(fields["value"][index])
        break;
      case 'addBefore':
        fields.insert(index, {})
        break;
      case 'addAfter':
        fields.insert(index + 1, {})
        break;
      default: null
    }
  }


  showModal = () => { this.setState({ visible: true, }) };

  handleOk = e => { this.setState({ visible: false, }) }

  handleCancel = e => { this.setState({ visible: false, }) }
  editProperty = e => {
    this.setState({ visible: true, })
    this.handleMenuClick({ e: 'editName' })
  }


  render() {
    const { fields, name, index, fieldsBuilder, children } = this.props
    return (
      <div className="columns-drag" >
        <span>{children}</span>&nbsp;
        <Dropdown overlay={
          <Menu onClick={this.handleMenuClick}>
            {MenuData.map(item => (<Menu.Item key={item.key}>{item.value}</Menu.Item>))}
          </Menu>
        }>
          <EllipsisOutlined style={{ padding: ' 5px 0', float: 'right', }} />
        </Dropdown>
        <EditOutlined style={{ padding: ' 3px 7px', float: 'right', }} onClick={this.editProperty} />
        <Modal
          title={children}
          destroyOnClose
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <div style={{ marginRight: 40 }}>{fieldsBuilder(name, index)}</div>
        </Modal>
      </div>
    )
  }
}

class EditTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}

    this.dragProps = {
      onDragEnd: (fromIndex, toIndex) => {
        this.props.fields.move(fromIndex, toIndex)
      },
      nodeSelector: 'th',
      handleSelector: '.columns-drag',
      // ignoreSelector:"columns-nodrag"
    }
  }

  handleResize = index => (e, { size }) => {
    const input = this.props.input
    const array = input.value || []
    const Width = (size.width > 120) ? size.width : 120

    if (array.length > index) {
      array[index] = { ...array[index], width: Width }
    }
    input.onChange([...array])
  }

  components = {
    header: {
      cell: ResizeableTitle,
    },
  }

  render() {
    const { fields, field, label, input, meta, fieldsBuilder } = this.props
    let n = 1
    let columns = fields.map((name, index) => {
      const value = fields.value[index] || {}
      const objectName = value.name || value.title || `未命名${n++}`
      return {
        title: [
          <ColumnsDropDown
            index={index}
            name={name}
            value={value}
            fields={fields}
            onClose={this.showDrawer}
            fieldsBuilder={fieldsBuilder}
          >
            {objectName}
          </ColumnsDropDown>
        ],
        dataIndex: name,
        onHeaderCell: column => ({
          width: column.width,
          onResize: this.handleResize(index),
        }),
        ...(fields.length - 1 > index ? { width: value.width || 150 } : {})
      }
    })
    const row = color => fields.map(() => <span style={{ color }}>xxx.xx</span>)

    const datas = [row('#666'), row('#BBB'), row('#EEE')]

    return (
      <div style={{ width: '100%' }} className="editTable">
        {
          columns.length > 0 ? <div className="editTable-Table">
            <ReactDragListView.DragColumn {...this.dragProps}>
              <Table
                columns={columns}
                pagination={false}
                components={this.components}
                dataSource={(columns && columns[0].dataIndex) ? datas : null}
                bordered
              />
            </ReactDragListView.DragColumn>
          </div> : <Empty className="editTable-Table" image={require('./../icon/homeIcon/undefinedTables.png')}
            imageStyle={{ height: 100 }}
            description={<span>未定义表格</span>} />
        }
      </div>
    )
  }
}

export default EditTable
